export default function Footer() {
  return (
    <footer className="mt-24 border-t border-slate-200 bg-slate-950 text-slate-400">
      <div className="nx-container py-16 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 bg-[#A3E635] flex items-center justify-center">
              <span className="text-slate-950 font-black text-lg leading-none">N</span>
            </div>
            <span className="font-black text-lg tracking-tighter text-white">NEXARA</span>
          </div>
          <p className="text-sm max-w-sm">The unified marketplace connecting global enterprises with retail buyers. Verified suppliers. Real-time logistics.</p>
          <p className="mono text-[10px] mt-6 text-slate-500">SHIPPING / TO / 200+ / COUNTRIES</p>
        </div>
        <div>
          <h4 className="mono text-[11px] text-white mb-4">MARKETPLACE</h4>
          <ul className="space-y-2 text-sm">
            <li>B2B Wholesale</li>
            <li>Retail Deals</li>
            <li>Flash Sales</li>
            <li>Enterprise Trade</li>
          </ul>
        </div>
        <div>
          <h4 className="mono text-[11px] text-white mb-4">FOR/BUYERS</h4>
          <ul className="space-y-2 text-sm">
            <li>Post RFQ</li>
            <li>Trade Assurance</li>
            <li>Payment Options</li>
            <li>Logistics</li>
          </ul>
        </div>
        <div>
          <h4 className="mono text-[11px] text-white mb-4">COMPANY</h4>
          <ul className="space-y-2 text-sm">
            <li>About Nexara</li>
            <li>Press</li>
            <li>Careers</li>
            <li>Contact</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-6 nx-container flex flex-col md:flex-row justify-between text-xs text-slate-500 gap-2">
        <span>© 2026 Nexara Global Trade. All rights reserved.</span>
        <span className="mono">BUILT/FOR/GLOBAL/COMMERCE</span>
      </div>
    </footer>
  );
}
